export const ApiDashboard = (axios, obuBaseUrl) => {
  const stats = async () => {
    const token = sessionStorage.getItem('token')
    if (token) {
      axios.setToken(token, 'Bearer')
    }

    const result = await axios.get('api/dashboard/stats')
    return result.data
  }

  return {
    dashboardStats: stats
  }
}
